/**
 * LoadingSpinner Component
 * Standardized loading indicator
 */

import React from 'react';
import { designTokens } from '../../constants/designTokens';

interface LoadingSpinnerProps {
  size?: 'sm' | 'md' | 'lg' | 'xl' | '2xl';
  className?: string;
}

export const LoadingSpinner = React.memo(function LoadingSpinner({
  size = 'md',
  className = '',
}: LoadingSpinnerProps) {
  const sizeMap = {
    sm: '24px',
    md: '48px',
    lg: '64px',
    xl: '80px',
    '2xl': '96px',
  };

  return (
    <>
      <div className={`loading-spinner loading-spinner-${size} ${className}`} />

      <style>{`
        .loading-spinner {
          border: 3px solid ${designTokens.colors.border.default};
          border-top-color: ${designTokens.colors.brand.primary};
          border-radius: ${designTokens.borderRadius.full};
          animation: spin 1s linear infinite;
        }
        
        .loading-spinner-sm {
          width: ${sizeMap.sm};
          height: ${sizeMap.sm};
          border-width: 2px;
        }
        
        .loading-spinner-md {
          width: ${sizeMap.md};
          height: ${sizeMap.md};
          border-width: 3px;
        }
        
        .loading-spinner-lg {
          width: ${sizeMap.lg};
          height: ${sizeMap.lg};
          border-width: 4px;
        }
        
        .loading-spinner-xl {
          width: ${sizeMap.xl};
          height: ${sizeMap.xl};
          border-width: 5px;
        }
        
        .loading-spinner-2xl {
          width: ${sizeMap['2xl']};
          height: ${sizeMap['2xl']};
          border-width: 6px;
        }
        
        /* Desktop responsive scaling */
        ${designTokens.media.desktop} {
          .loading-spinner-md {
            width: ${sizeMap.lg};
            height: ${sizeMap.lg};
            border-width: 4px;
          }
          
          .loading-spinner-lg {
            width: ${sizeMap.xl};
            height: ${sizeMap.xl};
            border-width: 5px;
          }
          
          .loading-spinner-xl {
            width: ${sizeMap['2xl']};
            height: ${sizeMap['2xl']};
            border-width: 6px;
          }
        }
        
        @keyframes spin {
          to { 
            transform: rotate(360deg); 
          }
        }
      `}</style>
    </>
  );
});
